import{__assign as o}from"../../../_virtual/_tslib.js";import r from"react";import{IconWrapper as t}from"./common.js";import{ReactComponent as m}from"../vectors/link.svg.js";var e=function(e){return r.createElement(t,o({icon:m},e))};export{e as IconLinkIcon};
//# sourceMappingURL=link-icon.js.map
